import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import {
  CollateralSearchParams,
  HypothecCollateral,
  HypothecCollateralsRequestServerData,
  CollateralViewParams,
  CollateralAddParams,
  CollateralOperParams,
  CollateralManagementViewParams,
  CollateralManagementOperParams,
} from './collateral.types'

export class CollateralProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  public collateralSearch(
    params: CollateralSearchParams,
    signal: AbortSignal,
  ): Promise<HttpServiceResponse<HypothecCollateral[]>> {
    const query = qs.stringify({
      ...params,
    })

    return this.http.post(`${this.baseUrl}/collateral_search_api.php?${query}`, {
      signal,
    })
  }

  public collateralView(
    params: CollateralViewParams,
  ): Promise<HttpServiceResponse<HypothecCollateralsRequestServerData>> {
    const query = qs.stringify({
      ...params,
    })

    return this.http.post(`${this.baseUrl}/collateral_view_api.php?${query}`)
  }

  public collateralAdd(
    params: CollateralAddParams,
  ): Promise<HttpServiceResponse<HypothecCollateralsRequestServerData>> {
    const { ClientID, HashSum_ClientID_, CollateralID, HashSum_CollateralID_, action, ...rest } = params

    const query = qs.stringify({
      ClientID,
      HashSum_ClientID_,
      CollateralID,
      HashSum_CollateralID_,
      action,
    })

    return this.http.post(`${this.baseUrl}/collateral_add_api.php?${query}`, rest)
  }

  public collateralOper(params: CollateralOperParams): Promise<HttpServiceResponse<void>> {
    const query = qs.stringify({
      ...params,
    })

    return this.http.post(`${this.baseUrl}/collateral_oper_api.php?${query}`)
  }

  public collateralMngView(
    params: CollateralManagementViewParams,
  ): Promise<HttpServiceResponse<HypothecCollateralsRequestServerData>> {
    const query = qs.stringify({
      ...params,
    })

    return this.http.post(`${this.baseUrl}/collateral_mng_view_api.php?${query}`)
  }

  public collateralMngOper(
    params: CollateralManagementOperParams,
  ): Promise<HttpServiceResponse<HypothecCollateralsRequestServerData | void>> {
    const query = qs.stringify({
      ...params,
    })

    return this.http.post(`${this.baseUrl}/collateral_mng_oper_api.php?${query}`)
  }
}
